// *********************************
// Actions
// *********************************
const INIT_SESSION = "oauth/INIT_SESSION";
const INIT_SESSION_SUCCESS = "oauth/INIT_SESSION_SUCCESS";
const INIT_SESSION_FAIL = "oauth/INIT_SESSION_FAIL";
const SAVE_CREDENTIAL = "oauth/SAVE_CREDENTIAL";
const CLEAR_CREDENTIAL = "oauth/CLEAR_CREDENTIAL";
// *********************************
// Re-export Actions as constant
// *********************************
export const OAUTH_CONSTANT = {
  INIT_SESSION,
  INIT_SESSION_SUCCESS,
  INIT_SESSION_FAIL,
  SAVE_CREDENTIAL,
  CLEAR_CREDENTIAL,
};
// *********************************
// Reducer
// *********************************
const initialState = {
  initial: false,
  loading: false,
  access_token: null,
  refresh_token: null,
  ref_code: null,
  // user: null,
  error: null,
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_CREDENTIAL:
      return {
        ...state,
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        ref_code: action.payload.ref_code,
      };
    case CLEAR_CREDENTIAL:
      return {
        ...state,
        access_token: null,
        refresh_token: null,
        ref_code: null,
        // user: null,
      };
    case INIT_SESSION:
      return {
        ...state,
        initial: false,
        loading: true,
      };
    case INIT_SESSION_SUCCESS:
      return {
        ...state,
        initial: true,
        loading: false,
        error: null,
        // user: action.payload,
      };
    case INIT_SESSION_FAIL:
      return {
        ...state,
        initial: true,
        loading: false,
        access_token: null,
        refresh_token: null,
        ref_code: null,
        error: action.error,
        // user: null,
      };
    default:
      return state;
  }
}
// *********************************
// Action Creators
// *********************************
export function initSession() {
  return {
    type: INIT_SESSION,
  };
}

export function initSessionSuccess(user) {
  return {
    type: INIT_SESSION_SUCCESS,
    payload: user,
  };
}

export function initSessionFail(error) {
  return {
    type: INIT_SESSION_FAIL,
    error,
  };
}

// COMMENT: redirect = path หรือ false
export function saveCredential(
  access_token,
  refresh_token,
  ref_code,
  redirect = false
) {
  return {
    type: SAVE_CREDENTIAL,
    payload: {
      redirect,
      access_token,
      refresh_token,
      ref_code,
    },
  };
}

export function clearCrendential() {
  return {
    type: CLEAR_CREDENTIAL,
  };
}
